<template>
  <div>
    <v-container>
      <v-row
        v-if="
          (!this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook) ||
          (this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook)
        "
      >
        <v-col cols="12" class="text-center">
          <h2 class="compeatfont">Welcome to Compeat</h2>
          <p>Please sign in to Facebook</p>
          <v-btn
            small
            rounded
            @click="loginWithFacebook()"
            class="primary"
            :loading="facebookLoginLoading"
          >
            <v-icon>mdi-facebook</v-icon> Login To Facebook
          </v-btn>
          <p v-if="cancelledLogin">
            Client Cancelled Signin. please try again.
          </p>
        </v-col>
      </v-row>
      <v-row
        v-if="
          this.currentUser.facebookToken && this.$store.state.loggedIntoFacebook
        "
      >
        <v-col cols="12" sm="12" md="6" lg="6">
          <h2 class="compeatfont">Welcome {{ user.name }}</h2>
        </v-col>
        <v-col cols="6" class="text-right hidden-sm-and-down">
          <v-btn
            small
            rounded
            @click="logoutFromFacebook()"
            class="primary"
            :loading="facebookLoginLoading"
          >
            <v-icon>mdi-facebook</v-icon> Logout Facebook
          </v-btn>
        </v-col>
        <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4">
          <v-card
            v-if="!overlay"
            color="primary"
            dark
            flat
            class="px-3 py-3"
            @click="viewUsers()"
          >
            <v-row>
              <v-col class="col-12 danetest--text compeatfont">
                All Users
              </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large
                  >mdi-account-multiple</v-icon
                >
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>{{ agencySubscribers.length }}</h1>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader v-else height="120px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4">
          <v-card
            v-if="!overlay"
            color="compeatsecondary"
            dark
            flat
            class="px-3 py-3"
            @click="viewActiveSubscription()"
          >
            <v-row>
              <v-col class="col-12 danetest--text compeatfont">
                All Active Subscriptions
              </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-layers</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>{{ agencyActiveSubscriptions.length }}</h1>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader v-else height="120px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4">
          <v-card
            v-if="!overlay"
            color="compeatthird"
            dark
            flat
            class="px-3 py-3"
            @click="viewCancelledSubscription()"
          >
            <v-row>
              <v-col class="col-12 danetest--text compeatfont">
                Cancelled Subscriptions
              </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-layers-off</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>{{ agencyInactiveSubscriptions.length }}</h1>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader v-else height="120px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4">
          <v-card
            @click="viewDemoReports()"
            v-if="!overlay"
            color="compeatthird"
            dark
            flat
            class="px-3 py-3"
          >
            <v-row>
              <v-col class="col-12 danetest--text compeatfont">
                All Demo Subscriptions
              </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-timer-sand</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>{{ agencyDemoSubscriptions.length }}</h1>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader v-else height="120px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4"> </v-col>
        <v-col cols="12" sm="12" mb="8" lg="8" class="hidden-sm-and-down">
          <v-card v-if="!overlay">
            <v-card-text>
              <v-row>
                <v-col cols="8">
                  <h2 class="compeatfont">
                    Last {{ this.selectedDays }} Subscriptions And Demo Reports
                  </h2>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-select
                    outlined
                    :items="selectDays"
                    label="Select Number of Days"
                    v-model="selectedDays"
                    @change="handleDaysSelection"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <apexchart
                    type="line"
                    :options="options"
                    :series="series"
                    height="400px"
                  ></apexchart>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="580px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" mb="4" lg="4" class="text-center">
          <!-- <v-card v-if="!overlay" class="mb-3">
            <v-card-text>
              <v-row>
                <v-col cols="5" class="text-left">
                  <h2 class="compeatfont">Total Sales</h2>
                </v-col>
                <v-col cols="7" class="text-right">
                  <h2>$ 300</h2>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="53px" class="mx-auto" type="image">
          </v-skeleton-loader> -->
          <!-- <v-card flat>
            <v-card-text>
              <h2>Leader Board Sales</h2>
              <v-list>
                <v-list-item v-for="agency in allAcgencies" :key="agency.id">
                  {{ agency.agencyName }} <v-spacer></v-spacer>
                  {{ agency.subscriptionCount }}
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card> -->
          <v-card v-if="!overlay" flat>
            <v-card-text>
              <h2 class="compeatfont">Package Purchased Ratio</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPackages"
                :series="seriesPackages"
              ></apexchart>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="372px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "../alerts/generalAlert.vue";
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import moment from "moment-timezone";

const db = getFirestore(firebaseApp);

export default {
  props: ["uid", "user", "getcurrentuser"],
  components: {
    generalAlert,
  },
  data: () => ({
    //Boolean Values
    overlay: false,
    cancelledLogin: false,
    facebookLoginLoading: false,

    //user Info
    userToken: "",
    currentUser: {},

    //agency info
    agencyProfile: [],

    //Arrays of data
    agencySubscribers: [],
    agencyActiveSubscriptions: [],
    agencyInactiveSubscriptions: [],
    agencyDemoSubscriptions:[],
    demoReports: [],

    //Arrays and objects for charts
    seriesPackages: [],
    chartOptionsPackages: {},
    options: {},
    series: [],

    //data range
    selectDays: ["7 Days", "14 Days", "30 Days", "60 Days"],
    selectedDays: "7 Days",
  }),
  //facebook SDK
  mounted() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      FB.init({
        appId: "736605293879783",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v16.0",
      });
    };
  },
  //Created Hook - gets the user and checks for facebook userToken
  created() {
    this.overlay = true;
    this.currentUser = this.$store.state.user;
    console.log("this.currentUser", this.currentUser);
    if (this.currentUser.facebookToken) {
      this.checkTokenValid(this.currentUser.facebookToken);
    } else {
      this.$store.commit("setloggedIntoFacebook", false);
      this.overlay = false;
    }
  },
  methods: {
    //Validates the user token
    checkTokenValid(token) {
      this.facebookLoginLoading = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const checkIfTokenIsValid = httpsCallable(
        functions,
        "checkIfTokenIsValid"
      );
      checkIfTokenIsValid({
        token: token,
      })
        .then((result) => {
          console.log("checkTokenValid", result);
          if (result.data.response.valid) {
            console.log(
              "result.data.response.valid",
              result.data.response.valid
            );
            this.$store.commit("setloggedIntoFacebook", true);
            this.$store.commit("setUserToken", token);
            this.facebookLoginLoading = false;
            this.getAgencyInfo();
          }
        })
        .catch((err) => {
          this.facebookLoginLoading = false;
          this.errorToken =
            "Your user token is invalid please login to Facebook.";
          this.$store.commit("setloggedIntoFacebook", false);
          this.overlay = false;
        });
    },
    //Logs user in with facebook SDK
    loginWithFacebook() {
      this.facebookLoginLoading = true;
      //incase user did cancel the login process
      this.cancelledLogin = false;
      FB.login(
        (response) => {
          if (response.authResponse) {
            this.userToken = response.authResponse.accessToken;
            console.log("this.userToken", this.userToken);
            this.extendUserFacebookToken();
          } else {
            this.cancelledLogin = true;
            this.overlay = false;
            // this.loading = false
          }
        },
        {
          scope:
            "read_insights, pages_show_list, ads_management, ads_read, page_events, pages_read_engagement, pages_read_user_content, public_profile, instagram_basic, instagram_manage_insights",
        }
      );
    },
    //Extends the userToken of client once logged in
    async extendUserFacebookToken() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const extendAccessToken = httpsCallable(functions, "extendAccessToken");

      extendAccessToken({
        token: this.userToken,
      }).then((result) => {
        console.log("extendAccessToken", this.userToken);
        console.log("result.data.response", result.data.response);
        this.updateUserFacebookToken(result.data.response);
      });
    },
    //Updates the user in firebase with the extended Token
    async updateUserFacebookToken(result) {
      console.log("updateUserFacebookToken result", result);
      const ref = doc(db, "users", this.currentUser.id);
      await updateDoc(ref, {
        facebookToken: result,
      });
      this.loading = false;

      const ref2 = doc(db, "users", this.currentUser.id);
      const userUpdated = await getDoc(ref2);

      this.$store.commit("setUser", userUpdated.data());
      this.currentUser = userUpdated.data();

      this.facebookLoginLoading = false;
      this.checkTokenValid(this.currentUser.facebookToken);
    },
    //Logs out user using facebook SDK and clears the facebook userToken ine firebase
    logoutFromFacebook() {
      this.facebookLoginLoading = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const facebookLogoutUser = httpsCallable(functions, "facebookLogoutUser");

      facebookLogoutUser({
        userId: this.currentUser.id,
      })
        .then((result) => {
          console.log("result", result);
          this.$store.commit("setloggedIntoFacebook", false);
          this.$store.commit("setUserFacebookToken", false);
          FB.getLoginStatus(function (response) {
            if (response.status === "connected") {
              var accessToken = response.authResponse.accessToken;
              FB.logout(
                function (response) {
                  console.log(response);
                },
                { access_token: accessToken }
              );
            }
          });
          this.facebookLoginLoading = false;
        })
        .catch((err) => {
          console.log("Error Signing user out", err);
          this.facebookLoginLoading = false;
        });
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo() {
      try {
        const docRef = doc(db, "agencies", this.currentUser.agencyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.$store.commit("setAgency", this.agencyProfile);
          this.getAgencySubscribers();
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    async getAgencySubscribers() {
      this.agencySubscribers = [];
      try {
        const q = query(
          collection(db, "users"),
          where("agencyId", "==", this.currentUser.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let subscriber = doc.data();
          //if (subscriber.userType == "SB") {
          let createdMilliseconds = subscriber.dateRegistered;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
          subscriber.dateRegistered = formatCreatedDate;

          this.agencySubscribers.push(subscriber);

          // Sort the array by date
          this.agencySubscribers.sort((a, b) => {
            return new Date(b.dateRegistered) - new Date(a.dateRegistered);
          });
          //}
        });
        this.getAgencyActiveSubscriptions();
      } catch (err) {
        console.log("getAgencyActiveSubscriptions err", err);
        this.overlay = false;
      }
    },
    //gets all active subscriptions and filtes it by date
    async getAgencyActiveSubscriptions() {
      this.agencyActiveSubscriptions = [];
      this.agencyDemoSubscriptions = []
      try {
        const q = query(
          collection(db, "subscriptions"),
          where("agencyId", "==", this.currentUser.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();
          let createdMilliseconds = subscription.dateCreated;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
          subscription.dateCreated = formatCreatedDate;

          if (
            subscription.isActive == true &&
            subscription.agencyUser == this.$store.state.user.id &&
            this.$store.state.user.userType == "SMM" && 
            subscription.package.packageType == "CompEatPaid"
          ) {
            this.agencyActiveSubscriptions.push(subscription);
          } else if(
            subscription.isActive == true &&
            subscription.agencyUser == this.$store.state.user.id &&
            this.$store.state.user.userType == "SMM" && 
            subscription.package.packageType != "CompEatPaid"
            ){
              this.agencyDemoSubscriptions.push(subscription)
          }else if (
            subscription.isActive == true &&
            this.$store.state.user.userType == "AA" && 
            subscription.package.packageType == "CompEatPaid"
          ) {
            this.agencyActiveSubscriptions.push(subscription);
          }else if (
            subscription.isActive == true &&
            this.$store.state.user.userType == "AA" && 
            subscription.package.packageType != "CompEatPaid"
          ) {
            this.agencyDemoSubscriptions.push(subscription);
          }

          // Sort the array by date
          this.agencyActiveSubscriptions.sort((a, b) => {
            return new Date(b.dateCreated) - new Date(a.dateCreated);
          });
          // Sort the array by date
          this.agencyDemoSubscriptions.sort((a, b) => {
            return new Date(b.dateCreated) - new Date(a.dateCreated);
          });
        });

        console.log('this.agencyDemoSubscriptions', this.agencyActiveSubscriptions)

        //below data is for the pie graph
        const [headings, counts] = await this.processSubscriptions(
          this.agencyActiveSubscriptions
        );

        this.seriesPackages = counts;
        this.chartOptionsPackages = {
          labels: headings,
          dataLabels: {
            enabled: false,
          },
          responsive: [
            {
              breakpoint: 960,
              options: {
                chart: {
                  width: 290,
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
          legend: {
            position: "bottom",
          },
        };

        this.getAgencyInactiveSubscriptions();
      } catch (err) {
        console.log("getAgencyActiveSubscriptions err", err);
        this.overlay = false;
      }
    },
    //this processes the data for the pie chart above
    async processSubscriptions(subscriptions) {
      const packageCounts = {};

      subscriptions.forEach((subscription) => {
        const currentPackage = subscription.package.currentPackage;
        if (currentPackage) {
          if (packageCounts[currentPackage]) {
            packageCounts[currentPackage]++;
          } else {
            packageCounts[currentPackage] = 1;
          }
        }
      });

      const headings = Object.keys(packageCounts);
      const counts = Object.values(packageCounts);

      return [headings, counts];
    },
    //gets all inactive subscriptions and filtes it by date
    async getAgencyInactiveSubscriptions() {
      this.agencyInactiveSubscriptions = [];
      try {
        const q = query(
          collection(db, "cancelledsubscriptions"),
          where("agencyId", "==", this.currentUser.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();
          let createdMilliseconds = subscription.dateCreated;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
          subscription.dateCreated = formatCreatedDate;

          if (
            subscription.agencyUser == this.$store.state.user.id &&
            this.$store.state.user.userType == "SMM"
          ) {
            this.agencyInactiveSubscriptions.push(subscription);
          } else if (this.$store.state.user.userType == "AA") {
            this.agencyInactiveSubscriptions.push(subscription);
          }

          // this.agencyInactiveSubscriptions.push(subscription);

          // Sort the array by date
          this.agencyInactiveSubscriptions.sort((a, b) => {
            return new Date(b.dateCreated) - new Date(a.dateCreated);
          });
        });
        this.handleDaysSelection();
        // this.getAgencyDemos();
      } catch (err) {
        console.log("getAgencyActiveSubscriptions err", err);
        this.overlay = false;
      }
    },
    //gets all agency demo report and filters by date
    async getAgencyDemos() {
      this.demoReports = [];
      try {
        const q = query(
          collection(db, "demoreports"),
          where("agencyId", "==", this.currentUser.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let demoReport = doc.data();
          let createdDemoMilliseconds = demoReport.createdAt;
          let formatDemoCreatedDate = moment(createdDemoMilliseconds).format(
            "YYYY-MM-DD h:mm a"
          );
          demoReport.createdAt = formatDemoCreatedDate;
          let expiryMilliseconds = demoReport.expiresAt;
          let formatExpiresDate =
            moment(expiryMilliseconds).format("YYYY-MM-DD h:mm a");
          demoReport.expiresAt = formatExpiresDate;

          this.demoReports.push(demoReport);

          // Sort the array by date
          this.demoReports.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
        this.handleDaysSelection();
      } catch (err) {
        console.log("getAgencyDemos err", err);
        this.overlay = false;
      }
    },
    //day selector handels the date change
    async handleDaysSelection() {
      const numDays = parseInt(this.selectedDays);

      const result = await this.processReportDates(
        numDays,
        this.agencyActiveSubscriptions,
        "dateCreated"
      );
      const result2 = await this.processReportDates(
        numDays,
        this.agencyDemoSubscriptions,
        "dateCreated"
      );
      const result3 = await this.processReportDates(
        numDays,
        this.agencyInactiveSubscriptions,
        "dateCancelled"
      );

      this.options = {
        chart: {
          id: "vuechart-example",
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: result.reportDates,
        },
      };
      this.series = [
        {
          name: "Subscriptions",
          data: result.reportCounts,
        },
        {
          name: "Cancelled Subscriptions",
          data: result3.reportCounts,
        },
        {
          name: "Demo Reports",
          data: result2.reportCounts,
        },
      ];
      this.overlay = false;
      // return result;
    },
    //Processes the new arrays to have the new data
    async processReportDates(numDays, data, dateName) {
      const currentDate = new Date();
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(currentDate.getDate() - numDays);

      const reportDates = []; // Array to store dates
      const reportCounts = []; // Array to store counts

      const reportCountsPerDay = {};

      data.forEach((item) => {
        // subscription.reports.forEach((report) => {
        const reportDate = new Date(item[dateName]); // Assuming 'date' is the report date field

        if (reportDate >= oneWeekAgo && reportDate <= currentDate) {
          const formattedDate = reportDate.toISOString().split("T")[0];
          if (!reportCountsPerDay[formattedDate]) {
            reportCountsPerDay[formattedDate] = 0;
          }
          reportCountsPerDay[formattedDate]++;
        }
        // });
      });

      // Populate the arrays with dates and counts
      for (
        let date = oneWeekAgo;
        date <= currentDate;
        date.setDate(date.getDate() + 1)
      ) {
        const formattedDate = date.toISOString().split("T")[0];
        reportDates.push(formattedDate);
        reportCounts.push(reportCountsPerDay[formattedDate] || 0);
      }
      // this.options.xaxis.categories = reportDates;
      //console.log(reportDates, reportCounts, reportCountsPerDay);

      return {
        reportDates: reportDates,
        reportCounts: reportCounts,
        reportCountsPerDay: reportCountsPerDay,
      };
    },
    //agency-subscriptions page
    viewActiveSubscription() {
      this.$router.push({
        name: "agencySubscriptions",
      });
    },
    //users page
    viewUsers() {
      this.$router.push({
        name: "users",
      });
    },
    //Demo Reports
    viewDemoReports() {
      this.$router.push({
        name: "demoSubscriptions",
      });
    },
    //Cancelled subscriptions
    viewCancelledSubscription() {
      this.$router.push({
        name: "cancelledSubscriptions",
      });
    },
  },
};
</script>

<style>
.compeatfont {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  text-transform: uppercase;
}
</style>
